import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import Cookies from "universal-cookie";
import { includes, pathOr } from "ramda";

import UserService from "../../service/UserService";
import loginService from "../../service/login";
import CustomButton from "../customButton";
import CustomInput from "../customInput";
import CustomNotification from "../notification";
import { checkUserExist, LoginSagaAction } from "../../sagas/saga-actions";
import { setPopup } from "../../actions/popupAction";
import { ALLOWED_OTP_COUNTS } from "../../constants/constants";
import LoginLeftSection from "../loginLeftSection";
import Counter from "../counter";

const cookies = new Cookies();

const userservice = new UserService();

const LoginOtp = (props) => {
  const history = useHistory();
  const { customPopupMessage, messageType, message } = props.popupReducer;
  const otpToken = userservice?.getToken();
  const { otpAttempts, isSMS, data, otpTokenExpiresIn } =
    props?.location?.state || {};
  const otpAttemptsLeft =
    otpAttempts !== null ? ALLOWED_OTP_COUNTS - otpAttempts : null;

  const doNotHaveAccessPopup = () => {
    loginService.Logout();
    props.setPopup({
      customPopupMessage: true,
      message: "You do not have access",
      messageType: "error",
    });
    history.push("/login");
  };

  const [state, setState] = useState({
    loading: false,
    otpValue: "",
    otpToken,
    otpAttemptsLeft,
    isTimerOn: otpAttemptsLeft > 0 ? true : false,
  });
  const setTimer = useCallback((isTimerOn) => {
    setState((prev) => ({
      ...prev,
      isTimerOn,
    }));
  });

  const handleVerifyUser = async (values, e) => {
    const { username, password, rememberMe } = pathOr(
      {},
      ["location", "state"],
      props
    );
    e.preventDefault();
    try {
      const response = await userservice.verifyUser(state?.otpToken, values);

      const { userDetails } = response.data;
      const {
        liveChatEnabled,
        liveChatAccess,
        broadcastAccess,
        liveAgentAccess,
        reportOnlyAccess,
      } = userDetails;
      props.checkUserExist(userDetails);

      if (["OU", "TS", "HA"].includes(userDetails?.roles?.roleKey)) {
        if (
          liveChatEnabled === 0 &&
          ["HA"].includes(userDetails?.roles?.roleKey)
        ) {
          doNotHaveAccessPopup();
        }

        history.push({
          pathname: "/admin-login",
          state: {
            role: userDetails?.roles?.roleKey,
          },
        });
      } else if (
        userDetails.roles.roleKey === "CR" &&
        userDetails.roleType === "internal"
      ) {
        if (liveChatEnabled === 0) {
          doNotHaveAccessPopup();
        }

        history.push({
          pathname: "/admin-login",
          state: {
            role: userDetails?.roles?.roleKey,
          },
        });
      } else if (
        !userDetails?.directLoginLC &&
        userDetails.isConfig &&
        userDetails.roles.roleKey === "CR" &&
        userDetails.roles.accountAssociated === 0 &&
        userDetails.roleType === "external"
      ) {
        history.push({
          pathname: "/login-by-dept",
          state: {
            mainOrSub: userDetails?.mainOrSub,
            role: userDetails?.roles?.roleKey,
            roleType: userDetails?.roleType,
          },
        });
      } else if (
        userDetails.roles.roleKey === "CR" &&
        userDetails.roles.accountAssociated === 1 &&
        userDetails.roleType === "external"
      ) {
        if (liveChatEnabled === 0) {
          doNotHaveAccessPopup();
        }

        history.push({
          pathname: "/admin-login",
          state: {
            role: userDetails?.roles?.roleKey,
          },
        });
      } else if (!userDetails?.directLoginLC && userDetails.isConfig) {
        if (
          liveChatAccess ||
          broadcastAccess ||
          liveAgentAccess ||
          reportOnlyAccess
        ) {
          history.push({
            pathname: "/login-by-dept",
            state: {
              mainOrSub: userDetails?.mainOrSub,
              role: userDetails?.roles?.roleKey,
              roleType: userDetails?.roleType,
            },
          });
        } else {
          doNotHaveAccessPopup();
        }
      } else {
        if (!userDetails.practiceId) {
          props.setPopup({
            customPopupMessage: true,
            messageType: "error",
            message: `Invalid credentials!`,
          });
          return;
        }
        if (rememberMe === false) {
          loginService.doLogin(response.data?.userDetails, "", "");
        } else {
          loginService.doLogin(response.data?.userDetails, username, password);
        }
        props.LoginSagaAction(userDetails);
        props.checkUserExist(userDetails);
        props.setPopup({
          customPopupMessage: true,
          messageType: "success",
          message: `${loginService &&
            loginService.getName()} logged in Successfully`,
        });

        if (liveChatAccess || reportOnlyAccess) {
          history.push("/chat");
        } else if (liveAgentAccess) {
          history.push("/chat-agent");
        } else if (broadcastAccess || reportOnlyAccess) {
          history.push("/broadcast");
        } else {
          doNotHaveAccessPopup();
        }
      }
    } catch (err) {
      if (
        includes(
          401,
          pathOr(
            "Internal Server Error. Please check the connection",
            ["response", "data", "error"],
            err
          )
        )
      ) {
        history.push("/login");
      }
      props.setPopup({
        customPopupMessage: true,
        message: pathOr(
          "Internal Server Error. Please check the connection",
          ["response", "data", "message"],
          err
        ),
        messageType: "error",
      });
    }
  };

  const checkOtp = async () => {
    if (!state?.otpToken) {
      history.push("/");
    }
    if (cookies.get("username") && cookies.get("password")) {
      setState((st) => ({
        ...st,
        initialValuesLogin: {
          username: cookies.get("username"),
          password: cookies.get("password"),
        },
      }));
    }
  };

  useEffect(() => {
    window.addEventListener("beforeunload", userservice.removeToken);
    checkOtp();
    return () => {
      window.removeEventListener("beforeunload", userservice.removeToken);
    };
  }, []);

  const handleOtpChange = (e) => {
    e.persist();
    const re = /^[0-9\b]+$/;
    if ((e.target && e.target.value === "") || re.test(e.target.value)) {
      setState((st) => ({
        ...st,
        otpValue: e && e.target && e.target.value,
      }));
    }
  };

  const handleResendOtp = async (values, e) => {
    if (state.isTimerOn || state.otpAttemptsLeft === 0) return;
    try {
      const { username } = pathOr({}, ["location", "state"], props);
      setTimer(true);
      const data = await userservice.getOtp(username, isSMS);
      if (data?.data?.success) {
        const {
          data: { otpToken, otpTokenExpiresIn = 1 },
        } = data;
        // update cookie
        userservice.setToken(otpToken, otpTokenExpiresIn * 60);
        setState((st) => ({
          ...st,
          otpToken: data?.data?.otpToken,
          ...(data?.data?.otpAttempts && {
            otpAttemptsLeft: ALLOWED_OTP_COUNTS - data.data.otpAttempts,
          }),
        }));

        props.setPopup({
          customPopupMessage: true,
          message: `OTP has been re-sent successfully to the registered ${
            isSMS ? "phone number" : "email address"
          }`,
          messageType: "success",
        });
      } else {
        props.setPopup({
          customPopupMessage: true,
          message: pathOr("Something went wrong", ["data", "message"], data),
          messageType: "error",
        });
      }
    } catch (error) {
      props.setPopup({
        customPopupMessage: true,
        message: pathOr(
          "Something went wrong",
          ["response", "data", "message"],
          error
        ),
        messageType: "error",
      });

      if (error?.response?.data?.otpAttempts) {
        if (
          state.otpAttemptsLeft === null ||
          state.otpAttemptsLeft !==
            ALLOWED_OTP_COUNTS - error.response.data.otpAttempts
        ) {
          setState((prev) => ({
            ...prev,
            otpAttemptsLeft:
              ALLOWED_OTP_COUNTS - error.response.data.otpAttempts,
          }));
        }
      }
    }
  };

  const handleGoBack = () => {
    userservice.removeToken();

    history.push("/");
  };

  return (
    <div data-testid="otp-page-wrapper" className="login-page-wrapper">
      {customPopupMessage && (
        <CustomNotification messageType={messageType} message={message} />
      )}

      <main className="login-page-main">
        <LoginLeftSection />

        <section className="form-wrapper">
          <h2 className="form-heading">Two-Factor Authentication</h2>
          <p className="form-caption">
            A 6-Digit code has been sent to your{" "}
            {isSMS ? "phone number" : "email address"}
          </p>
          <form className="login-form">
            <section className="custom-input-group otp-field">
              <label className="input-label">Authentication Code</label>
              <article className="otp-field-wrapper">
                <CustomInput
                  className={"custom-form-input"}
                  placeholder="Enter code..."
                  onChange={handleOtpChange}
                  value={state?.otpValue}
                  type="otp"
                  name="otp"
                  autoFocus
                  data-testid="otp-field"
                />
              </article>
            </section>

            <section className="login-otp-options">
              <div className="resend-code">
                {!state.isTimerOn ? (
                  <>
                    Didn&apos;t receive the code?{" "}
                    <span
                      className={`login-link ${
                        state.otpAttemptsLeft ? "" : "disabled"
                      }`}
                      onClick={state.otpAttemptsLeft ? handleResendOtp : null}
                    >
                      Resend Code
                    </span>
                  </>
                ) : (
                  <>
                    The code has been sent to {data}
                    <Counter
                      countOver={() => setTimer(false)}
                      countDownTimeValue={otpTokenExpiresIn * 60}
                    />
                  </>
                )}
              </div>
              <div
                className={`resend-code-otpcount ${
                  state.otpAttemptsLeft !== null && state.otpAttemptsLeft > 0
                    ? "otpcount-green"
                    : "otpcount-red"
                }`}
              >
                {state.otpAttemptsLeft !== null &&
                  `You have ${state.otpAttemptsLeft} attempts left`}
              </div>
              <div className="resend-code-guidelines">
                <ul>
                  <li>{`Resend OTP code is allowed only once in ${
                    otpTokenExpiresIn === 1
                      ? "a minute"
                      : `${otpTokenExpiresIn} minutes`
                  }`}</li>
                  <li>
                    Resend OTP code is only allowed maximum of 3 times in 30
                    mins
                  </li>
                </ul>
              </div>
            </section>
            <article className="otp-buttons">
              <CustomButton
                htmlType="submit"
                type="primary"
                className={state?.otpValue?.length < 6 ? "disable-button" : ""}
                disabled={state?.otpValue?.length < 6 ? true : false}
                onClick={(e) => handleVerifyUser(state?.otpValue, e)}
                title="Submit"
                testid="otp-submit-button"
              />
              <CustomButton
                htmlType="submit"
                type="primary"
                className="cancel-button ml-8"
                onClick={handleGoBack}
                title="Go Back"
              />
            </article>
          </form>
        </section>
      </main>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    popupReducer: state.popupReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    LoginSagaAction: (data) => {
      dispatch(LoginSagaAction(data));
    },
    checkUserExist: (data) => dispatch(checkUserExist(data)),
    setPopup: (data) => dispatch(setPopup(data)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LoginOtp)
);
